import { Select, Spin } from "antd";
import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import {
  ROLL_CALL_API_BASE_URL,
  ROLL_CALL_GET_LEAVE_TYPES,
  ROLL_CALL_SAVE_LEAVE,
} from "../RollCallConfig/RollCallConfig";
import PropTypes from "prop-types";

const ApplyLeave = ({ handleLeavesView, onClose, isOpen }) => {
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [selectedLeaveType, setSelectedLeaveType] = useState();
  const [halfDay, setHalfDay] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [comments, setComments] = useState("");
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);

  const navigate = useNavigate();

  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const regId = userData?.RegId;

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (tokenData) {
      const fetchLeaveTypes = async () => {
        try {
          const response = await fetch(
            `${ROLL_CALL_API_BASE_URL}${ROLL_CALL_GET_LEAVE_TYPES}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
            },
          );

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }

          const data = await response.json();

          if (data.status && data.ResultData) {
            const options = data.ResultData.map((item) => ({
              value: item.Id,
              label: item.LvType,
            }));
            setLeaveTypes(options);
          } else {
            console.error("Invalid data format:", data);
          }
        } catch (error) {
          console.error("Error fetching leave types:", error);
        }
      };

      fetchLeaveTypes();
    }
  }, [tokenData]);

  const calculateLeaveCount = (start, end, isHalfDay) => {
    const startDt = new Date(start);
    const endDt = new Date(end);

    // +1 to include both start and end dates
    const dayDiff = (endDt - startDt) / (1000 * 60 * 60 * 24) + 1;

    // If half-day is selected, count is 0.5 regardless of range
    if (isHalfDay) return 0.5;

    return dayDiff;
  };

  const handleSubmit = () => {
    setLoadingBtn(true);
    const payload = {
      inputdata: {
        superid: superIdData,
        regid: regId,
        lvtypeid: selectedLeaveType.value,
        startdate: startDate,
        enddate: endDate,
        leavecount: calculateLeaveCount(startDate, endDate, halfDay),
        comments: comments,
        halfday: halfDay ? 1 : 0,
      },
    };
    console.log(JSON.stringify(payload));
    fetch(`${ROLL_CALL_API_BASE_URL}${ROLL_CALL_SAVE_LEAVE}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${tokenData}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Response data:", data);

        if (data.status === true) {
          Swal.fire({
            title: "Success!",
            text: "Your leave request has been saved.",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            handleLeavesView();
            onClose();
          });
        } else {
          Swal.fire({
            title: "Error!",
            text: "There was an issue saving your leave request. Please try again.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      })
      .catch((error) => {
        console.error("Error saving leave:", error);
        Swal.fire({
          title: "Error!",
          text: "There was an error while submitting the request. Please try again later.",
          icon: "error",
          confirmButtonText: "OK",
        });
      })
      .finally(() => {
        setLoadingBtn(false);
      });
  };

  const handlecancel = () => {
    setSelectedLeaveType();
    setHalfDay(false);
    setStartDate("");
    setEndDate("");
    setComments("");
  };

  useEffect(() => {
    const offcanvasEl = document.getElementById("offcanvasRightApplyLeave");

    const handleOffcanvasClose = () => {
      handlecancel();
    };

    if (offcanvasEl) {
      offcanvasEl.addEventListener("hidden.bs.offcanvas", handleOffcanvasClose);
    }

    return () => {
      if (offcanvasEl) {
        offcanvasEl.removeEventListener(
          "hidden.bs.offcanvas",
          handleOffcanvasClose,
        );
      }
    };
  }, []);
  return (
    <>
      <div>
        <style>
          {`
            .offcanvas {
          transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
          visibility: hidden;
          will-change: transform;
        }

        .offcanvas.show {
          visibility: visible;
        }

        .offcanvas-backdrop {
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .offcanvas-backdrop.show {
          opacity: 0.5;
        }
        @media (max-width: 576px) {
          #offcanvasRightApplyLeave {
            width: 90% !important;
          }
        }

        @media (min-width: 577px) and (max-width: 992px) {
          #offcanvasRightApplyLeave {
            width: 55% !important;
          }
        }

          @media (min-width: 993px) and (max-width: 1440px) {
          #offcanvasRightApplyLeave {
            width: 35% !important;
          }
        }
          
        @media (min-width: 1441px) and (max-width:2550px) {
          #offcanvasRightApplyLeave {
            width: 20% !important;
          }
        }
        @media (min-width:2551px) {
          #offcanvasRightApplyLeave {
            width:17% !important;
          }
        }
        `}
        </style>

        {loadingBtn && (
          <div
            className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
            style={{
              zIndex: 1050,
              backdropFilter: "blur(4px)",
              backgroundColor: "rgba(255, 255, 255, 0.2)",
            }}
          >
            <Spin size="large" tip="Processing..." />
          </div>
        )}
        <div
          className={`offcanvas-backdrop fade ${isOpen ? "show" : ""}`}
          style={{ pointerEvents: isOpen ? "auto" : "none" }}
          onClick={onClose}
        />

        <div
          id="offcanvasRightApplyLeave"
          className={`offcanvas offcanvas-end ${isOpen ? "show" : ""}`}
          style={{ pointerEvents: isOpen ? "auto" : "none" }}
        >
          <div className="offcanvas-header">
            <h4>Apply Leave</h4>
            <button
              type="button"
              className="btn-close"
              onClick={() => {
                handlecancel();
                onClose();
              }}
            />
          </div>
          <hr />
          <div className="offcanvas-body">
            <form>
              <div className="row">
                <div className="col-6 mb-3">
                  <label className="form-label">
                    <span className="text-danger ms-1">*</span>Start Date
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    required
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">
                    <span className="text-danger ms-1">*</span>End Date
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    required
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">
                    <span className="text-danger">*</span>Leave Type
                  </label>
                  <Select
                    style={{ width: "" }}
                    className="w-100"
                    placeholder="Leave Type"
                    value={selectedLeaveType?.value}
                    onChange={(value) => {
                      const selectedOption = leaveTypes.find(
                        (option) => option.value === value,
                      );
                      setSelectedLeaveType(selectedOption);
                    }}
                    options={leaveTypes}
                  />
                </div>

                <div className="col-6 mb-3">
                  <label className="form-label">Half-Day</label>
                  <input
                    type="checkbox"
                    className="form-check ms-2"
                    checked={halfDay}
                    onChange={(e) => setHalfDay(e.target.checked)}
                  />
                </div>
                <div className="col-12">
                  <label className="form-label">Reason</label>
                  <textarea
                    className="form-control"
                    value={comments}
                    onChange={(e) => setComments(e.target.value)}
                  />
                </div>
              </div>
              <div className="d-flex justify-content-end mt-3">
                <button
                  type="button"
                  className="btn btn-secondary me-2"
                  // data-bs-dismiss="offcanvas"
                  onClick={() => {
                    handlecancel();
                    onClose();
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-success"
                  disabled={loadingBtn}
                  onClick={handleSubmit}
                >
                  {loadingBtn ? "Saving..." : "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

ApplyLeave.propTypes = {
  handleLeavesView: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.func.isRequired,
};

export default ApplyLeave;
